import tbl from './entityTable.module.css';

/**
 * Renders an entity's hierarchy path (the slash-separated subgroup chain).
 *
 * Truncates with an ellipsis and exposes the full value via the native title
 * tooltip. Shows a dash for entities without a hierarchy (e.g. CDTs).
 *
 * @param {object} props
 * @param {string} props.parent  slash-separated path, '' when there is none
 */
export default function EntityPath({ parent }) {
  if (!parent) {
    return <span className={tbl.entityPathEmpty}>—</span>;
  }
  return (
    <span className={tbl.entityPath} title={parent}>
      {parent}
    </span>
  );
}
